import React from "react";
import { Link, useHistory } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styled from "styled-components";
import TopGenresContainer from "./TopGenresContainer";
import TopArtistsContainer from "./TopArtistsContainer";
import TopChimneysContainer from "./TopChimneysContainer";
import Spinner from "react-bootstrap/Spinner";

export const ListNumber = styled.section`
  display: inline-block;
  width: 42px;
  text-align: right;
  padding-right: 12px;
`;
export const StatsList = styled.section`
  a {
    color: "#66c";
  }
`;

const StatsPage = ({ match }) => {
  return (
    <StatsList>
      <React.Fragment>
        <Row>
          <Col xs={12} style={{ marginBottom: "20px" }}>
            <h1>Track Stats</h1>
          </Col>
        </Row>
        <Row className="with-col-list">
          <Col xs={12} sm={12} md={4}>
            <h3>Top Genres</h3>
            <TopGenresContainer
              render={({ genres, loading }) => {
                if (loading)
                  return (
                    <div>
                      <Spinner animation="border" size="sm" /> Loading...
                    </div>
                  );
                else {
                  return genres.map((genre, index) => {
                    return (
                      <div className="statsList">
                        <ListNumber>{index === 0 || genres[index - 1].rank !== genre.rank ? <span>#{genre.rank}</span> : null}</ListNumber>
                        <Link to={`/genre/${genre.id}`}>{genre.genre}</Link> [{genre.total}]
                        {index + 1 === genres.length ? (
                          <div style={{ marginTop: "20px" }}>
                            <ListNumber></ListNumber>
                            <Link to={`/genres`}>View all genres</Link>
                          </div>
                        ) : null}
                      </div>
                    );
                  });
                }
              }}
            />
          </Col>
          <Col xs={12} sm={12} md={4}>
            <h3>Top Artists</h3>
            <TopArtistsContainer
              render={({ artists, loading }) => {
                if (loading)
                  return (
                    <div>
                      <Spinner animation="border" size="sm" /> Loading...
                    </div>
                  );
                else {
                  return artists.map(({ artist, total }) => {
                    return (
                      <div>
                        <Link to={`/artist/${artist}`}>{artist}</Link> [{total}]
                      </div>
                    );
                  });
                }
              }}
            />
          </Col>
          <Col xs={12} sm={12} md={4}>
            <h3>Top Chimneys</h3>
            <TopChimneysContainer
              render={({ chims, loading }) => {
                if (loading)
                  return (
                    <div>
                      <Spinner animation="border" size="sm" /> Loading...
                    </div>
                  );
                else {
                  return chims.map((chim) => {
                    return (
                      <div>
                        <Link to={`/profile/${chim.chim_dir}`}>{chim.full_name} Chimney</Link> [{chim.total}]
                      </div>
                    );
                  });
                }
              }}
            />
          </Col>
        </Row>
      </React.Fragment>
    </StatsList>
  );
};

export default StatsPage;
